module.exports = __webpack_public_path__ + "static/media/decorationBacgroundUpper.e4b4e13e.png";